import * as React from "react"
import { checkSection } from "../helper-functions"
import { Box, Container, Section } from "./ui"

const SectionLayout = (props) => {
  return (
    <>
      {props.cardImage ? (
        <Section background={checkSection(props.index)}>
          <Container width="fullbleed">{props.children}</Container>
        </Section>
      ) : (
        <Section background={checkSection(props.index)}>
          <Container width="fullbleed">
            <Box paddingMain paddingY={5} background="white">
              {props.children}
            </Box>
          </Container>
        </Section>
      )}
    </>
  )
}

export default SectionLayout
